import dealerApi from '../../apis/dealer.api';
let getDealerLicensePromise = null;
export default {
  state: {
    licenseUrl: ''
  },
  mutations: {
    setLicenseUrl (state, licenseUrl) {
      state.licenseUrl = licenseUrl;
    }
  },
  getters: {
    licenseUrl: state => state.licenseUrl
  },
  actions: {
    getDealerLicense ({ commit }, dealerId) {
      if (getDealerLicensePromise) {
        return getDealerLicensePromise;
      }
      getDealerLicensePromise = dealerApi.getDealerLicense(dealerId).then(function (dealer) {
        var licenseUrl = dealer.LicenseUrl;
        if (licenseUrl) {
          commit('setLicenseUrl', licenseUrl);
        }
        return Promise.resolve(dealer);
      });
      return getDealerLicensePromise;
    }
  },
  namespaced: true
};
